"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AiNoticeGate = AiNoticeGate;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _alertDialog = require("@design/ui/alert-dialog");
var _useAiNoticeGate2 = require("@common/hooks/use-ai-notice-gate");
var _useFetchApi2 = require("@common/hooks/useFetchApi");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AiNoticeGate(_ref) {
  var orgId = _ref.orgId,
    userId = _ref.userId,
    orgMetadata = _ref.orgMetadata,
    onAcknowledged = _ref.onAcknowledged,
    children = _ref.children;
  var _useFetchApi = (0, _useFetchApi2.useFetchApi)(),
    fetchWeb = _useFetchApi.fetchWeb;
  var _useAiNoticeGate = (0, _useAiNoticeGate2.useAiNoticeGate)({
      orgId: orgId,
      userId: userId,
      orgMetadata: orgMetadata,
      fetchWeb: fetchWeb
    }),
    pendingNotice = _useAiNoticeGate.pendingNotice,
    acknowledge = _useAiNoticeGate.acknowledge;
  function handleAcknowledge() {
    if (!pendingNotice) return;
    onAcknowledged(pendingNotice);
    acknowledge();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [children, pendingNotice && /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialog, {
      open: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogContent, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogHeader, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogTitle, {
            children: "Before you continue"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogDescription, {
            children: pendingNotice.text
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogFooter, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogAction, {
            "data-autofocus": true,
            onClick: handleAcknowledge,
            children: "I understand"
          })
        })]
      })
    })]
  });
}
var _default = exports.default = AiNoticeGate;